import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { SystemRole } from './interfaces/system-role';
import { Agency } from './interfaces/agency';
import { Stamp } from './interfaces/stamp';

@Injectable({
  providedIn: 'root'
})
export class AgencyManagementSystemService {
  private api: string = '';
  constructor(
    private http: HttpClient
  ) {
    this.api = environment.amsAPI;
  }

  /**
   * Get the system roles for the current user.
   */
  getSystemRoles(): Observable<SystemRole[]> {
    return this.http.get<SystemRole[]>(`${this.api}system-roles`);
  }
  /**
   * Get the agencies that the current user is a part of.
   */
  getAgencies(): Observable<Agency[]> {
    return this.http.get<Agency[]>(`${this.api}agencies`);
  }

  getGlassAgencies() : Observable<Agency[]> {
    return this.http.get<Agency[]>(`${this.api}glassAgencies`);
  }
  /**
   * Get the application stamps for the user.
   */
  getApplicationStamps(): Observable<Stamp[]> {
    return this.http.get<Stamp[]>(`${this.api}application-stamps`);
  }
}